import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { colors } from '@guryou/colors';
import { Modal, openModal, resetModal } from '@guryou/html-components';
import { authCookie, cognitoLogout, handleLoginFromCookie, logoutCookie } from '@guryou/redux';
import LogoLight from 'assets/img/guryouFeelLogos/gyFeelLogo13.png';
import Logo from 'assets/img/logo.png';
import ForgotPassword from 'containers/authComponents/ForgotPassword';
import Login from 'containers/authComponents/Login';
import SignUp from 'containers/authComponents/SignUp';
import ProfileMenu from './ProfileMenu';

const menuItems = [
  { label: 'READ', route: `/read`, requiresLogin: false },
  { label: 'BOOK', route: `/book`, requiresLogin: false },
  { label: 'VIDEO', route: `/videos`, requiresLogin: false },
  { label: 'MY VIDEOS', route: `/my-video-courses`, requiresLogin: true },
];

const SubHeader = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { auth } = useSelector(state => state);
  const hasAuthData = !auth.data;

  const [view, setView] = useState();
  const currentLogo = history.location.pathname === '/' ? LogoLight : Logo;
  const isHome = history.location.pathname === '/';

  useEffect(() => {
    if (authCookie() && hasAuthData) {
      dispatch(handleLoginFromCookie(authCookie()));
    }
    if (!hasAuthData) {
      dispatch(resetModal());
    }
  }, [dispatch, hasAuthData]);

  const handleLogInOrLogOut = viewType => {
    if (auth.data) {
      dispatch(cognitoLogout());
      logoutCookie();
      return;
    }
    setView(viewType);
    dispatch(openModal('modal'));
  };

  const renderMenuItems = () => {
    if (isHome) {
      return (
        <div
          data-is-home={isHome}
          class="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1 bg-gray-900 data-[is-home=false]:bg-white rounded sm:bg-transparent mt-4"
          id="mobile-menu-2"
        >
          <ul
            data-is-home={isHome}
            class="flex flex-col font-medium lg:flex-row lg:space-x-8 lg:mt-0 text-white p-2 absolute my-auto left-1/2 transform -translate-x-1/2"
          >
            {menuItems.map((element, idx) => {
              const showItem = element.requiresLogin ? (auth.data ? true : false) : true;

              return (
                showItem && (
                  <li>
                    <a
                      href={element.route}
                      key={`${idx}_${element.label}`}
                      data-focus={element.route === history.location.pathname}
                      class={`
                      block 
                      py-2 
                      pr-4 
                      pl-3 
                      lg:hover:bg-transparent 
                      lg:border-0 
                      lg:hover:text-primary-700 
                      lg:p-0 
                      capitalize
                      text-white
                      data-[focus=true]:font-bold
                      data-[focus=true]:border-b-2
                      data-[focus=true]:border-[${colors.mandy}]
                      data-[is-home=false]:text-gray-700
                      data-[focus=true]:text-[${colors.mandy}]
                      hover:border-[${colors.mandy}]
                      hover:text-[${colors.mandy}]
                      hover:border-b-2
                      hover:font-bold
                  `}
                    >
                      {element.label}
                    </a>
                  </li>
                )
              );
            })}
          </ul>
        </div>
      );
    }

    return (
      <div
        class="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1 bg-gray-900 rounded sm:bg-transparent mt-4"
        id="mobile-menu-2"
      >
        <ul
          data-is-home={isHome}
          class="flex flex-col font-medium lg:flex-row lg:space-x-8 lg:mt-0 text-white p-2 absolute my-auto left-1/2 transform -translate-x-1/2"
        >
          {menuItems.map((element, idx) => {
            const showItem = element.requiresLogin ? (auth.data ? true : false) : true;

            return (
              showItem && (
                <li key={idx}>
                  <a
                    href={element.route}
                    key={`${idx}_${element.label}`}
                    data-focus={element.route === history.location.pathname}
                    data-is-home={isHome}
                    class={`
                      block 
                      py-2 
                      pr-4 
                      pl-3 
                      lg:hover:bg-transparent 
                      lg:border-0 
                      lg:hover:text-primary-700 
                      lg:p-0 
                      capitalize
                      text-white
                      sm:text-gray-900
                      data-[focus=true]:font-bold
                      data-[focus=true]:border-b-2
                      data-[focus=true]:border-[${colors.mandy}]
                      data-[focus=true]:text-[${colors.mandy}]
                      hover:border-[${colors.mandy}]
                      hover:text-[${colors.mandy}]
                      hover:border-b-2
                      hover:font-bold
                  `}
                  >
                    {element.label}
                  </a>
                </li>
              )
            );
          })}
        </ul>
      </div>
    );
  };

  // if (history.location.pathname === '/') {
  //   return null;
  // }

  return (
    <header class={`absolute z-20 w-full top-12  ${!isHome ? 'bg-white' : 'bg-transparent'}`}>
      <nav class="border-gray-200 px-4 lg:px-6 py-2.5">
        <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl relative">
          <a href="/" class="flex items-center">
            <img src={currentLogo} class="mr-3 h-6 sm:h-9" alt="Flowbite Logo" />
          </a>
          <div class="flex items-center lg:order-2">
            {auth.data ? (
              <ProfileMenu />
            ) : (
              <>
                <button
                  class={`${isHome ? 'text-white' : 'text-gray-700'} hover:text-[${
                    colors.mandy
                  }] hover:underline font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none`}
                  onClick={() => handleLogInOrLogOut('login')}
                >
                  {t(`GENERAL.${auth.data ? 'logout' : 'login'}`)}
                </button>
                <button
                  class={`text-white bg-[${colors.mandy}] hover:bg-primary-800 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none`}
                  onClick={() => handleLogInOrLogOut('register')}
                >
                  {t('GENERAL.register')}
                </button>
              </>
            )}
            <button
              data-collapse-toggle="mobile-menu-2"
              type="button"
              class="inline-flex items-center p-2 ml-4 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
              aria-controls="mobile-menu-2"
              aria-expanded="false"
            >
              <span class="sr-only">Open main menu</span>
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          {renderMenuItems()}
        </div>
      </nav>
      <Modal key="loginModal" id="modal" title={t(`GENERAL.${view}`)} className="myModal">
        {view === 'login' ? <Login setView={setView} /> : view === 'register' ? <SignUp /> : <ForgotPassword />}
      </Modal>
    </header>
  );
};

export default SubHeader;
